import React from 'react'
import { Button } from 'react-bootstrap'
import { useConfig } from "../../../hooks/use-config"


const CTAButton = ({ product }) => {

  const getButtonLabel = () => {
    let btnText = 'Get Started'
    if (product.group_display_name === 'Freemium') {
      btnText = 'Try Now for Free'
    } else if (product.group_display_name === 'Starter') {
      btnText = 'Continue with Starter'
    } else if (product.group_display_name === 'Pro') {
      btnText = 'Continue with Pro'
    }
    return btnText
  }
  const { clearout: clearoutConfig } = useConfig()

  const onCTABtnClicked = () => {
    let queryString = '?redirect=' + encodeURIComponent('/pricing')

    if (product.group_display_name !== 'Freemium') {
      let queryParams = new URLSearchParams({
        showbuynow: 'true',
        currency: product.price.currency,
        product_id: product._id,
      }).toString()

      queryString = '?redirect=' + encodeURIComponent('/pricing?') + encodeURIComponent(queryParams)
    }

    window.open(clearoutConfig.app.registerUrl + queryString, '_blank');
  }

  return (
    <Button
      variant={product.group_display_name !== 'Pro' ? 'outline-secondary' : 'primary'}
      className='purchase-btn-text'
      onClick={onCTABtnClicked}
    >
      {getButtonLabel()}
    </Button>
  )
}

export default CTAButton